type Faq = { q: string; a: string };

const FAQS_BY_LOCALE: Record<string, Faq[]> = {
  en: [
    {
      q: "What is hantavirus?",
      a: "Hantaviruses are a family of viruses spread mainly by rodents. Some strains cause severe illness in humans — Hantavirus Pulmonary Syndrome (HPS) in the Americas and Hemorrhagic Fever with Renal Syndrome (HFRS) in Europe and Asia.",
    },
    {
      q: "How is it transmitted?",
      a: "Most human infections occur via inhalation of aerosolised rodent urine, droppings, or saliva. Person-to-person transmission is documented for the Andes virus only.",
    },
    {
      q: "Where does this data come from?",
      a: "We aggregate from WHO, CDC, PAHO, and ProMED. Every numeric field on the site carries a source URL and a verified-at timestamp.",
    },
    {
      q: "How often is the site updated?",
      a: "Outbreak counts and ticker items refresh every 5 minutes. Ship positions update every 30 seconds via AIS streams.",
    },
  ],
  ar: [
    {
      q: "ما هو فيروس هانتا؟",
      a: "فيروسات هانتا هي مجموعة من الفيروسات تنتقل بشكل رئيسي عن طريق القوارض. بعض السلالات تسبب مرضا شديدا لدى الإنسان.",
    },
    {
      q: "كيف ينتقل؟",
      a: "تحدث معظم الإصابات البشرية عن طريق استنشاق رذاذ بول أو فضلات أو لعاب القوارض.",
    },
    {
      q: "من أين تأتي هذه البيانات؟",
      a: "نجمع البيانات من منظمة الصحة العالمية ومراكز السيطرة على الأمراض ومنظمة الصحة للبلدان الأمريكية وبرنامج رصد الأمراض الناشئة.",
    },
    {
      q: "كم مرة يتم تحديث الموقع؟",
      a: "تتحدث أعداد الحالات والأخبار كل 5 دقائق. مواقع السفن تتحدث كل 30 ثانية.",
    },
  ],
  fr: [
    {
      q: "Qu'est-ce que l'hantavirus ?",
      a: "Les hantavirus sont une famille de virus principalement transmis par les rongeurs. Certaines souches provoquent une maladie grave chez l'homme.",
    },
    {
      q: "Comment se transmet-il ?",
      a: "La plupart des infections humaines surviennent par inhalation d'urine, d'excréments ou de salive de rongeurs en aérosol.",
    },
    {
      q: "D'où proviennent ces données ?",
      a: "Nous agrégeons l'OMS, le CDC, la PAHO et ProMED. Chaque chiffre porte une URL source et un horodatage de vérification.",
    },
    {
      q: "À quelle fréquence le site est-il mis à jour ?",
      a: "Les chiffres et le bandeau d'actualités sont rafraîchis toutes les 5 minutes. Les positions de navires toutes les 30 secondes.",
    },
  ],
};

type Props = { locale: string };

export { Page };

function Page({ locale }: Props) {
  const faqs = FAQS_BY_LOCALE[locale] ?? FAQS_BY_LOCALE.en;
  const heading: Record<string, string> = {
    en: "Frequently asked questions",
    ar: "الأسئلة الشائعة",
    fr: "Questions fréquentes",
  };

  return (
    <main id="main-content">
      <h1>{heading[locale] ?? heading.en}</h1>
      {faqs.map((faq) => (
        <section key={faq.q}>
          <h2>{faq.q}</h2>
          <p>{faq.a}</p>
        </section>
      ))}
    </main>
  );
}
